export default __webpack_public_path__ + "static/media/manufacturer2.b4e16c07.png";